import { SVGProps } from 'react';

export default function TrafficLightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <rect
        x="10.9199"
        y="5.67411"
        width="8.16016"
        height="18.6518"
        rx="4.08008"
        fill="#0A0E14"
      />
      <path
        d="M17.0877 9.81605C17.0877 10.9613 16.1532 11.8897 15.0004 11.8897C13.8477 11.8897 12.9132 10.9613 12.9132 9.81605C12.9132 8.67081 13.8477 7.74241 15.0004 7.74241C16.1532 7.74241 17.0877 8.67081 17.0877 9.81605Z"
        fill="#C22217"
      />
      <path
        d="M17.0877 15C17.0877 16.1452 16.1532 17.0736 15.0004 17.0736C13.8476 17.0736 12.9131 16.1452 12.9131 15C12.9131 13.8547 13.8476 12.9263 15.0004 12.9263C16.1532 12.9263 17.0877 13.8547 17.0877 15Z"
        fill="#FFCC00"
      />
      <path
        d="M17.0877 20.184C17.0877 21.3292 16.1532 22.2576 15.0004 22.2576C13.8476 22.2576 12.9131 21.3292 12.9131 20.184C12.9131 19.0387 13.8476 18.1103 15.0004 18.1103C16.1532 18.1103 17.0877 19.0387 17.0877 20.184Z"
        fill="#006F51"
      />
    </svg>
  );
}
